module.exports = __webpack_public_path__ + "img/festival-premio.fc69ee1d.png";